import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.removeEmailParam()
  }

  removeEmailParam() {
    const url = new URL(window.location.href)

    if (!url.searchParams.has("email")) return

    url.searchParams.delete("email")
    window.history.replaceState({}, "", url.toString())
  }
}
